import { makeStyles, shorthands } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  root: {
    flex: 1,
    overflowY: "auto",
    padding: `${designTokens.spacing[8]} ${designTokens.spacing[8]}`,
    fontFamily: projectIqTokens.fontFamily,
  },
  content: {
    maxWidth: "800px",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[6],
  },
  fileListGroup: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[2],
  },
  columnHeaderRow: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[3],
    padding: `0 ${designTokens.spacing[4]}`,
  },
  fileNameColumnHeader: {
    flex: 1,
    minWidth: 0,
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.semibold,
    color: projectIqTokens.muted,
  },
  sharedDateColumnHeader: {
    width: "168px",
    flexShrink: 0,
    textAlign: "left",
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.semibold,
    color: projectIqTokens.muted,
  },
  fileListCard: {
    borderRadius: "14px",
    border: `1px solid ${projectIqTokens.line}`,
    backgroundColor: projectIqTokens.card,
    boxShadow: projectIqTokens.shadowSm,
    ...shorthands.overflow("hidden"),
  },
  fileRow: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[3],
    padding: `${designTokens.spacing[3]} ${designTokens.spacing[4]}`,
    borderBottom: `1px solid ${projectIqTokens.line2}`,
    "&:last-child": {
      borderBottom: "none",
    },
  },
  fileIconWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "40px",
    height: "40px",
    ...shorthands.borderRadius(designTokens.borderRadius.md),
    flexShrink: 0,
  },
  fileIconPdf: {
    backgroundColor: "rgba(194,85,63,0.12)",
    color: projectIqTokens.rust,
  },
  fileIconXls: {
    backgroundColor: "rgba(47,158,110,0.12)",
    color: projectIqTokens.green,
  },
  fileIconPpt: {
    backgroundColor: "rgba(217,138,43,0.12)",
    color: projectIqTokens.amber,
  },
  fileIconDefault: {
    backgroundColor: projectIqTokens.bg2,
    color: projectIqTokens.ink3,
  },
  fileInfo: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minWidth: 0,
  },
  fileName: {
    fontSize: "13.5px",
    fontWeight: designTokens.fontWeight.semibold,
    color: projectIqTokens.ink2,
    whiteSpace: "nowrap",
    ...shorthands.overflow("hidden"),
    textOverflow: "ellipsis",
  },
  fileMeta: {
    fontSize: designTokens.fontSize.xs,
    color: projectIqTokens.ink3,
  },
  sharedDate: {
    width: "168px",
    flexShrink: 0,
    textAlign: "left",
    fontSize: designTokens.fontSize.xs,
    color: projectIqTokens.ink3,
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: designTokens.spacing[3],
    paddingTop: designTokens.spacing[8],
    color: projectIqTokens.muted,
  },
  errorBox: {
    padding: designTokens.spacing[3],
    backgroundColor: "rgba(194,85,63,0.12)",
    color: projectIqTokens.rust,
    borderRadius: designTokens.borderRadius.md,
    fontSize: designTokens.fontSize.sm,
  },
});
